import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isPlatformServer } from '@angular/common';

export interface CarouselItem {
  id?: string;
  image1?: string;
  heading?: string;
  description?: string;
  redirect?: boolean;
  link?: string;
  bg?: number;
}

@Injectable({
  providedIn: 'root'
})
export class CarouselService {
  private carousel: string;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // SSR/prerender: Node.js cannot resolve relative URLs — use absolute API host.
    // Browser: use relative path so the Angular dev proxy (proxy.config.json) and
    //          production Express proxy handle routing (avoids CORS entirely).
    if (isPlatformServer(this.platformId)) {
      this.carousel = 'https://api.softnetcomputers.lk/api/carousels/web';
    } else {
      this.carousel = '/api/carousels/web';
    }
  }

  getWebCarousels(page: number = 0, size: number = 20): Observable<CarouselItem[]> {
    let params = new HttpParams();
    params = params.append('page', page.toString());
    params = params.append('size', size.toString());
    return this.http.get<CarouselItem[]>(this.carousel, { params });
  }
}
